import { SvgIcon as MuiSvgIcon, Button as MuiButton } from '@mui/material';
import { FunctionComponent } from 'react';

import Icons from '@Constants/Icons.constants';

import { ButtonProps } from './Button.types';

export const Button: FunctionComponent<ButtonProps> = (
  props: ButtonProps
): JSX.Element => {
  const { children, text, icon, iconColor, variant, ...resProps } = props;

  const btnStyles =
    icon &&
    (variant === 'text'
      ? {
          pl: 1.2,
          pr: 1.6,
          minWidth: '10.7rem',
        }
      : {
          pl: 1.2,
          minWidth: '11.8rem',
        });

  return (
    <MuiButton
      {...resProps}
      variant={variant}
      startIcon={
        icon && <MuiSvgIcon color={iconColor}>{Icons[icon]}</MuiSvgIcon>
      }
      sx={{ ...btnStyles, ...resProps.sx }}
    >
      {children || text}
    </MuiButton>
  );
};

Button.defaultProps = {
  variant: 'contained',
};

export default Button;
